import { MentalHealthCareProviderSchema } from "../types/mentalHealthCareProvider.js";
import { trustA } from "./trusts.js";
import { slamMhaUser1, slamMhaUser2 } from "./users.js";
export const mentalHealthCareProviderOne = MentalHealthCareProviderSchema.parse({
    id: "100c3d58-74e0-448e-a55b-9cc431d802f4",
    name: `Mental Health Care Provider One (${slamMhaUser1.name})`,
    email: slamMhaUser1.email,
    trustId: trustA.id,
});
export const mentalHealthCareProviderTwo = MentalHealthCareProviderSchema.parse({
    id: "200c3d58-74e0-448e-a55b-9cc431d802f4",
    name: `Mental Health Care Provider Two (${slamMhaUser2.name})`,
    email: slamMhaUser2.email,
    trustId: trustA.id,
});
export const defaultMentalHealthCareProviders = [
    mentalHealthCareProviderOne,
    mentalHealthCareProviderTwo,
];
//# sourceMappingURL=mentalHealthCareProviders.js.map